// extracted by mini-css-extract-plugin
export var black = "_4l-6";
export var brand = "_4l-1";
export var ddefault = "_4l-0";
export var error = "_4l-3";
export var gray = "_4l-2";
export var highContrast = "_4l-8";
export var outline = "_4l-7";
export var success = "_4l-5";
export var warning = "_4l-4";